import { directus } from "@/lib/directus";
import {
  readItems,
  updateItem,
  deleteItem,
  deleteItems,
} from "@directus/sdk";
import type { Notificacion } from "@/types/models/notificaciones";
import type { NotificacionesRepository } from "@/lib/repositories/interfaces/notificaciones-repository.interface";

export const notificacionesRepository: NotificacionesRepository = {
  async fetchByUser(userId: string): Promise<Notificacion[]> {
    const items = await directus.request<Notificacion[]>(
      readItems("notificaciones", {
        filter: {
          usuario: { id: { _eq: userId } },
        },
        sort: ["-date_created"],
      })
    );

    return items ?? [];
  },

  async markAsRead(id: string): Promise<void> {
    await directus.request(
      updateItem("notificaciones", id, {
        estado: "leida",
      })
    );
  },

  async markAsActive(id: string): Promise<void> {
    await directus.request(
      updateItem("notificaciones", id, {
        estado: "activa",
      })
    );
  },

  async delete(id: string): Promise<void> {
    await directus.request(deleteItem("notificaciones", id));
  },

  async deleteMany(ids: string[]): Promise<void> {
    await directus.request(deleteItems("notificaciones", ids));
  },

  async waitForToken(): Promise<void> {
    for (let i = 0; i < 8; i++) {
      try {
        const token = await directus.getToken();
        if (token) return;
      } catch {}

      await new Promise((resolve) => setTimeout(resolve, 150));
    }
  },
};
